import { NOTIFICATION_TEMPLATE_EDITOR_PATH } from "@/modules/admin-panel/notification-templates/pages/notification-template-editor";
import { generatePath, Navigate } from "react-router-dom";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export function OpenNotificationTemplate() {
  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");

  if (!id) {
    return <ToPageNotFound />;
  }

  return (
    <Navigate to={generatePath(NOTIFICATION_TEMPLATE_EDITOR_PATH, { id })} />
  );
}
